import type { TravelerFormValues } from '../../api/reservationInfo';

export const SHINKANSEN_ADDRESS_TYPES = {
  select: 'select',
  text: 'text',
  organizationBaseSelect: 'organization_base_select'
} as const;

export type ShinkansenAddressType = typeof SHINKANSEN_ADDRESS_TYPES[keyof typeof SHINKANSEN_ADDRESS_TYPES];

export type ShinkansenFormValues = {
  shinkansenAddressType: ShinkansenAddressType;
  postcode: string;
  shinkansenAddress: string;
  shinkansenAddressee: string;
  shinkansenTicketType: 'normal' | 'kyuusyuu' | 'bulk_ticket' | 'ex';
  shinkansenSeatType: 'free' | 'reserve' | 'green';
  shinkansenSeat: '指定なし' | '窓側' | '通路側' | 'その他' | '';
  shinkansenSeatDetail: string;
  exicNumber: string;
  exicPassword: string;
  exicCardId: number | null;
  departmentId: number | null;
  organizationBaseId: number | null;
  organizationAddressId: number | null;
};

export type CommonFormValues = {
  finalDestination: string;
  purpose: string;
  internalNumber: string;
  chargingDepartmentId: number | null;
  projectId: number | null;
};

export type CommonErrors = Partial<Record<keyof CommonFormValues, string>>;

export type FormValues = {
  finalDestination: string;
  purpose: string;
  internalNumber: string;
  chargingDepartmentId: number | null;
  projectId: number | null;
  traveler: TravelerFormValues | null;
  shinkansen: ShinkansenFormValues | null;
};
